<template>
  <v-textarea
    outlined
    v-bind="$attrs"
    :rules="rules"
    auto-grow
    counter
    :value="value"
    @input="handleChange"
    @paste="$emit('paste', $event)"
    @click="$emit('click', $event)"
    @keypress="$emit('keypress', $event)"
  ></v-textarea>
</template>
<script>
export default {
  name: 'custom-text-area',
  data() {
    return {
      rules: [(v) => v.length <= this.maxCharacter || this.errorTooLongMsg],
    };
  },
  methods: {
    handleChange(val) {
      this.$emit('input', val);
    },
  },
  created() {
    if (this.required) {
      this.rules.push((v) => v.length >= 1 || 'Champ obligatoire');
    }
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    maxCharacter: {
      type: Number,
      default: 4000,
      required: false,
    },
    errorTooLongMsg: {
      type: String,
      default: 'Maximum 4000 caractères',
      required: false,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
